import * as React from 'react';
import { cn } from '@/lib/utils';

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
  ({ className, type, ...props }, ref) => (
    <input
      type={type}
      className={cn(
        'flex h-10 w-full rounded-lg border border-input bg-white px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground/70',
        'focus-visible:border-[#70aa96] focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-success/10',
        'disabled:cursor-not-allowed disabled:bg-muted disabled:opacity-70 read-only:bg-muted/60',
        'aria-[invalid=true]:border-destructive aria-[invalid=true]:ring-destructive/10',
        'file:border-0 file:bg-transparent file:text-sm file:font-medium',
        className,
      )}
      ref={ref}
      {...props}
    />
  ),
);
Input.displayName = 'Input';

export { Input };
